import { useEffect } from "react";
import { Background, DotItem, DotRow, Header, LoaderShell, LoaderSvg, Container, Logo, AnalyseTitle } from "./IntroScreen.style";
import Analytics from "../../../../utils/analytics";

type IntroScreenProps = {
    isExiting?: boolean;
    cookieAnswered?: boolean;
};

export default function IntroScreen({ isExiting = false, cookieAnswered = false }: IntroScreenProps) {

    useEffect(() => {
        if(cookieAnswered) {
            Analytics.getInstance().trackBehaviourProfilingLoader();
        }
    }, [cookieAnswered]);

    return (
        <Container isExiting={isExiting}>
            <Background>
                <AnalyseTitle>Ases adfærdsanalyse</AnalyseTitle>
                <Header>Et øjeblik, spørgsmålene klargøres</Header>
                <DotRow>
                    <DotItem className="dot-1" animationRunning={cookieAnswered} />
                    <DotItem className="dot-2" animationRunning={cookieAnswered} />
                    <DotItem className="dot-3" animationRunning={cookieAnswered} />
                    <DotItem className="dot-4" animationRunning={cookieAnswered} />
                    <DotItem className="dot-5" animationRunning={cookieAnswered} />
                </DotRow>
                <LoaderShell>
                    <LoaderSvg viewBox="0 0 100 100" aria-hidden="true" animationRunning={cookieAnswered}>
                        <g transform="translate(50 50)">
                            <ellipse className="petal petal-1" cx="0" cy="-15" rx="9" ry="15" fill="#BCD4B6" fillOpacity="0.5" stroke="#BCD4B6" strokeWidth="4"></ellipse>
                            <ellipse className="petal petal-2" cx="14" cy="-5" rx="9" ry="15" fill="#B0C5D8" fillOpacity="0.5" stroke="#B0C5D8" strokeWidth="4" transform="rotate(72 14 -5)"></ellipse>
                            <ellipse className="petal petal-3" cx="9" cy="12" rx="9" ry="15" fill="#C5BDD9" fillOpacity="0.5" stroke="#C5BDD9" strokeWidth="4" transform="rotate(144 9 12)"></ellipse>
                            <ellipse className="petal petal-4" cx="-9" cy="12" rx="9" ry="15" fill="#DEC894" fillOpacity="0.5" stroke="#DEC894" strokeWidth="4" transform="rotate(216 -9 12)"></ellipse>
                            <ellipse className="petal petal-5" cx="-14" cy="-5" rx="9" ry="15" fill="#E7BDB3" fillOpacity="0.5" stroke="#E7BDB3" strokeWidth="4" transform="rotate(288 -14 -5)"></ellipse>
                        </g>
                        <text className="petal-label label-1" x="50" y="12">Fremdrift</text>
                        <text className="petal-label label-2" x="82" y="29">Tryghed</text>
                        <text className="petal-label label-3" x="73" y="83">Balance</text>
                        <text className="petal-label label-4" x="27" y="83">Relation</text>
                        <text className="petal-label label-5" x="18" y="29">Struktur</text>
                        <circle cx="50" cy="50" r="12.5" fill="#fff"></circle>
                    </LoaderSvg>
                    <Logo src="/assets/images/ase_logo.svg" alt="Ase Logo" />
                </LoaderShell>
            </Background>
        </Container>
    );
}